import React from 'react';
import './Section.css';

const Section = ({ slogan }) => {
  return (
    <div className="section-divider">
      <h2 className="section-slogan">{slogan}</h2>
    </div>
  );
};

export default Section;